import {
  contactsInitCallCreateMutation,
  leadsLogsListQueryKey,
  opportunitiesLogsListQueryKey
} from '@crm/api'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation, useQuery } from '@tanstack/react-query'
import { App } from 'antd'

import { useParams } from 'react-router-dom'

import { ActionsType } from './types'

export const OpportunityCall = ({ opportunity, onCancel }: ActionsType) => {
  const { t } = useLocales()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { id: leadId } = useParams()

  const { notification } = App.useApp()

  const id = 'contact' in opportunity && opportunity?.contact?.id

  const { mutateAsync } = useMutation({
    ...contactsInitCallCreateMutation(),
    onSuccess: () => {
      notification.success({
        message: t('success.success'),
        description: t('success.call_was_init')
      })
      onCancel()
      invalidateQueries([
        leadsLogsListQueryKey({ path: { lead_id: String(leadId) } }),
        opportunitiesLogsListQueryKey({
          path: { opportunity_id: String(opportunity.id) }
        })
      ])
    },
    onError: (e) => {
      showApiErrors(e)
      onCancel()
    }
  })

  useQuery({
    queryFn: () => mutateAsync({ path: { id: Number(id) } }),
    queryKey: [id],
    enabled: !!id
  })

  return null
}
